module.exports = __webpack_public_path__ + "static/media/loly.b32928c7.png";